import type {
  SolicitacaoAnalise,
  SolicitacaoDetalhe,
} from "../../../../services";
import {
  analiseCriterioComRespostaAposSolicitacao,
  listarAnalisesCriterio,
} from "../../../../domain/shipping/analiseCriterioList";

type AnaliseComMetadadosRaiz = SolicitacaoAnalise & {
  enviadoPeloSindicatoEm?: string | null;
  adequacaoSolicitadaEm?: string | null;
  adequacaoRealizadaEm?: string | null;
  criteriosLiberadosParaAdequacaoIds?: number[] | null;
};

function inferCriteriosLiberadosParaAdequacao(
  analise: SolicitacaoAnalise,
): number[] | null {
  const ids: number[] = [];
  for (const g of analise.grupos || []) {
    for (const c of g.criterios || []) {
      const arr = listarAnalisesCriterio(c.analise);
      const pendente = arr.some(
        (an) =>
          Boolean(an?.solicitadoEm && String(an.solicitadoEm).trim() !== "") &&
          !analiseCriterioComRespostaAposSolicitacao(an),
      );
      if (pendente) ids.push(c.id);
    }
  }
  return ids.length > 0 ? ids : null;
}


function inferAdequacaoSolicitadaEmPorCriterios(
  analise: SolicitacaoAnalise,
): string | null {
  let min: string | null = null;
  for (const g of analise.grupos || []) {
    for (const c of g.criterios || []) {
      const arr = listarAnalisesCriterio(c.analise);
      for (const an of arr) {
        if (
          Boolean(an?.solicitadoEm && String(an.solicitadoEm).trim() !== "") &&
          !analiseCriterioComRespostaAposSolicitacao(an)
        ) {
          const s = an.solicitadoEm!;
          if (!min || new Date(s) < new Date(min)) min = s;
        }
      }
    }
  }
  return min;
}


export function solicitacaoDetalheFromAnalise(
  analise: SolicitacaoAnalise,
): SolicitacaoDetalhe {
  const grupos = (analise.grupos || []).map((g) => ({
    ...g,
    prazoLimite: g.prazoLimite ?? "",
    criterios: (g.criterios || []).map((c) => ({ ...c })),
  }));

  const ext = analise as AnaliseComMetadadosRaiz;
  const inferidos = inferCriteriosLiberadosParaAdequacao(analise);
  const primeiraSolicitacaoPendente =
    inferAdequacaoSolicitadaEmPorCriterios(analise);

  return {
    id: analise.id,
    cnpj: analise.dados?.cnpj ?? "",
    sigla: analise.dados?.sigla ?? "",
    status: analise.status ?? { id: 0, nome: "—" },
    grupos: grupos as SolicitacaoDetalhe["grupos"],
    dados: analise.dados,
    enviadoPeloSindicatoEm: ext.enviadoPeloSindicatoEm ?? null,
    adequacaoSolicitadaEm:
      ext.adequacaoSolicitadaEm ?? primeiraSolicitacaoPendente,
    adequacaoRealizadaEm: ext.adequacaoRealizadaEm ?? null,
    criteriosLiberadosParaAdequacaoIds:
      ext.criteriosLiberadosParaAdequacaoIds ?? inferidos,
  };
}
